// extracted by mini-css-extract-plugin
export var siteFooter = "Footer-module--site-footer--sft5E";
export var subFooter = "Footer-module--sub-footer--36070";
export var subFooterPink = "Footer-module--sub-footer-pink--2slwE";
export var subNav = "Footer-module--sub-nav--3Xx13";
export var cookieButtons = "Footer-module--cookie-buttons--3LQnV";
export var menu = "Footer-module--menu--2hf4Z";
export var nav = "Footer-module--nav--3zea4";
export var cookieList = "Footer-module--cookie-list--2RCHL";
export var dark = "Footer-module--dark--27-uJ";
export var social = "Footer-module--social--37P8E";
export var socialNav = "Footer-module--social-nav--3HtxB";
export var logo = "Footer-module--logo--3rjYC";
export var subSection = "Footer-module--sub-section--HbTTO";
export var copyright = "Footer-module--copyright--1AZ0w";
export var sparkFooter = "Footer-module--spark-footer--aL7Dk";